import booleanIntersects from '@turf/boolean-intersects';
import turfIntersect from '@turf/intersect';
import { featureCollection } from '@turf/helpers';
import turfArea from '@turf/area';

export function findOverlaps(parcel, layers) {
  const overlaps = [];

  for (const { id, data } of layers) {
    if (!data || !data.features) continue;

    for (const feature of data.features) {
      try {
        if (booleanIntersects(parcel, feature)) {
          let overlapArea = null;
          let overlapPercentage = null;

          try {
            const fc = featureCollection([parcel, feature]);
            const intersection = turfIntersect(fc);
            if (intersection) {
              overlapArea = turfArea(intersection);
              const parcelArea = turfArea(parcel);
              if (parcelArea > 0) {
                overlapPercentage = Math.round((overlapArea / parcelArea) * 100);
              }
            }
          } catch {
            // Intersection calculation failed — still report the boolean overlap
          }

          overlaps.push({
            layerId: id,
            feature,
            overlapArea,
            overlapPercentage,
          });
          break; // One overlap per layer is enough for regulation matching
        }
      } catch {
        // Skip invalid geometries
      }
    }
  }

  return overlaps;
}
